import { homedir } from 'node:os';
import { join, isAbsolute } from 'node:path';

/**
 * Resolve the Max config directory.
 *
 * Global config (settings, keys, memory, scratchpad, caches, gateway state) lives
 * in the user's home directory so the CLI works the same regardless of the current
 * working directory — this is what makes `npx` installs behave. Override with the
 * MAX_HOME environment variable (absolute path, or relative to cwd).
 *
 * Note: `getMaxDir()` now returns an ABSOLUTE path. Consumers that previously
 * assumed a cwd-relative value must not re-join it with `process.cwd()`.
 */
function resolveMaxDir(): string {
  const override = process.env.MAX_HOME;
  if (override && override.trim()) {
    const value = override.trim();
    return isAbsolute(value) ? value : join(process.cwd(), value);
  }
  return join(homedir(), '.max');
}

const MAX_DIR = resolveMaxDir();

export function getMaxDir(): string {
  return MAX_DIR;
}

export function maxPath(...segments: string[]): string {
  return join(getMaxDir(), ...segments);
}
